import React, { useState } from "react";

import clsx from "clsx";

import { Button } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

import { SignUpForm } from "./sign-up-form";

interface Props {
  email?: string;
  goToSignIn: () => void;
  redirect_url?: string;
  email_opt_in: boolean;
}

export const ContinueWithEmail: React.FC<Props> = ({
  email,
  email_opt_in,
  goToSignIn,
  redirect_url
}) => {
  const { translator } = useAppContext();
  const [is_signup_form_shown, showSignUpForm] = useState(!!email);

  return (
    <>
      <Button
        variant="contained"
        size="lg"
        onClick={() => showSignUpForm(true)}
        className={clsx({
          hidden: is_signup_form_shown
        })}
      >
        {translator.t("!account.authentication.email")}
      </Button>
      <div
        className={clsx({
          hidden: !is_signup_form_shown
        })}
      >
        <SignUpForm
          email={email}
          goToSignIn={goToSignIn}
          redirect_url={redirect_url}
          email_opt_in={email_opt_in}
        />
      </div>
    </>
  );
};
